import { render, staticRenderFns } from "./UpsertRewardAffiliate.vue?vue&type=template&id=9f008ce0&scoped=true"
import script from "./UpsertRewardAffiliate.vue?vue&type=script&lang=js"
export * from "./UpsertRewardAffiliate.vue?vue&type=script&lang=js"
import style0 from "./UpsertRewardAffiliate.vue?vue&type=style&index=0&id=9f008ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f008ce0",
  null
  
)

export default component.exports